<template>
	<div class="login_page">
		<div class="wrap">
			<div class="card">
				<h1 class="logo">
					<img src="@/assets/images/logo.png" alt="janopay logo image" />
				</h1>
				<div v-if="!otpTokenRequired">
					<form v-on:submit.prevent="loginBtnClick">
						<input
							type="text"
							id="user"
							class="mb_10"
							v-model="user.user_id"
							:placeholder="$t('auth.id')"
						/>
						<input
							type="password"
							v-model="user.password"
							:placeholder="$t('auth.password')"
						/>
						<div class="mt_30">
							<button type="submit" class="login_button w100">
								{{ $t('auth.login_btn') }}
							</button>
						</div>
						<div class="line mt_20 mb_20">{{ $t('auth.or') }}</div>
						<div>
							<button
								type="button"
								class="signup_button w100"
								v-on:click="toSignup"
							>
								{{ $t('auth.signup_btn') }}
							</button>
						</div>
						<p class="mt_20 mb_20">
							<router-link
								:to="{ name: 'auth-find-account' }"
								class="fc_red fs_14"
								>{{ $t('rtr_auth-login.text1') }}</router-link
							>
						</p>
					</form>
				</div>
				<div v-else>
					<form v-on:submit.prevent="loginBtnClick">
						<input
							type="text"
							class="mb_10"
							v-model="user.otp_token"
							placeholder="OTP"
						/>
						<div class="mt_30">
							<button type="submit" class="login_button w100">
								{{ $t('button.confirm') }}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'Login',
	data() {
		return {
			user: {
				user_id: '',
				password: '',
				otp_token: '',
			},
			otpTokenRequired: false,
			loading: false,
		};
	},
	computed: {
		...mapGetters('auth', ['is_logged_in']),
	},
	created() {
		if (this.is_logged_in) {
			this.$router.push({ name: 'auth-dashboard' });
		}
	},
	methods: {
		toSignup() {
			this.$router.push({ name: 'auth-register' });
		},
		async validation() {
			if (!this.user.user_id) alert(this.$t('alert.request_id'));
			else if (!this.user.password) alert(this.$t('alert.request_pw'));
			else return true;
		},
		loginBtnClick() {
			this.validation().then(result => {
				if (!result) return false;
				else this.loginHandler(this.user);
			});
		},
		loginHandler(user) {
			this.loading = true;
			this.$store
				.dispatch('auth/login', user)
				.then(result => {
					if (result?.otp_token_required) {
						this.otpTokenRequired = result.otp_token_required;
					} else {
						location.href = this.$router.resolve({
							name: 'auth-dashboard',
						}).href;
					}
				})
				.catch(error => {
					this.message =
						(error.response &&
							error.response.data &&
							error.response.data.message) ||
						error.message ||
						error.toString();
					alert(this.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
